<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.status === 'recorded'" size="small" type="info">Rögzítve</el-tag>
      <el-tag v-if="scope.row.status === 'sent'" size="small" type="primary">Rakodási listán</el-tag>
      <el-tag v-if="scope.row.status === 'cancelled'" size="small" type="danger">Lemondva</el-tag>
      <el-tag v-if="scope.row.status === 'done'" size="small" type="success">Elküldve</el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'status',
};
</script>
